/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseClient } from '../base-client';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { buildRecipientList } from '../fn/edit-mailing-list-page/build-recipient-list';
import { BuildRecipientList$Params } from '../fn/edit-mailing-list-page/build-recipient-list';
import { deleteMailingList } from '../fn/edit-mailing-list-page/delete-mailing-list';
import { DeleteMailingList$Params } from '../fn/edit-mailing-list-page/delete-mailing-list';
import { MailingListDto as FeatureMailingListsMailingListDto } from '../models/feature/mailing-lists/mailing-list-dto';
import { PageDataDto as FeatureMailingListsPageDataDto } from '../models/feature/mailing-lists/page-data-dto';
import { RecipientDto as FeatureMailingListsRecipientDto } from '../models/feature/mailing-lists/recipient-dto';
import { getPageData } from '../fn/edit-mailing-list-page/get-page-data';
import { GetPageData$Params } from '../fn/edit-mailing-list-page/get-page-data';
import { updateMailingList } from '../fn/edit-mailing-list-page/update-mailing-list';
import { UpdateMailingList$Params } from '../fn/edit-mailing-list-page/update-mailing-list';

@Injectable({ providedIn: 'root' })
export class EditMailingListPageClient extends BaseClient {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `editMailingListPageGetPageData()` */
  static readonly EditMailingListPageGetPageDataPath = '/edit-mailing-list-page/data/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPageData()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPageData$Response(id: number, context?: HttpContext): Observable<StrictHttpResponse<FeatureMailingListsPageDataDto | undefined>> {
    const obs = getPageData(this.http, this.rootUrl, { id } satisfies GetPageData$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPageData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPageData(id: number, context?: HttpContext): Observable<FeatureMailingListsPageDataDto | undefined> {
    const resp = this.getPageData$Response(id, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FeatureMailingListsPageDataDto | undefined>): FeatureMailingListsPageDataDto | undefined => r.body)
    );
  }

  /** Path part for operation `editMailingListPageBuildRecipientList()` */
  static readonly EditMailingListPageBuildRecipientListPath = '/edit-mailing-list-page/build-recipient-list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `buildRecipientList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  buildRecipientList$Response(body: BuildRecipientList$Params['body'], context?: HttpContext): Observable<StrictHttpResponse<Array<FeatureMailingListsRecipientDto>>> {
    const obs = buildRecipientList(this.http, this.rootUrl, { body } satisfies BuildRecipientList$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `buildRecipientList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  buildRecipientList(body: BuildRecipientList$Params['body'], context?: HttpContext): Observable<Array<FeatureMailingListsRecipientDto>> {
    const resp = this.buildRecipientList$Response(body, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<FeatureMailingListsRecipientDto>>): Array<FeatureMailingListsRecipientDto> => r.body)
    );
  }

  /** Path part for operation `editMailingListPageDeleteMailingList()` */
  static readonly EditMailingListPageDeleteMailingListPath = '/edit-mailing-list-page/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteMailingList()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteMailingList$Response(id: number, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteMailingList(this.http, this.rootUrl, { id } satisfies DeleteMailingList$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteMailingList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteMailingList(id: number, context?: HttpContext): Observable<void> {
    const resp = this.deleteMailingList$Response(id, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `editMailingListPageUpdateMailingList()` */
  static readonly EditMailingListPageUpdateMailingListPath = '/edit-mailing-list-page/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateMailingList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateMailingList$Response(id: number, body: UpdateMailingList$Params['body'], context?: HttpContext): Observable<StrictHttpResponse<FeatureMailingListsMailingListDto>> {
    const obs = updateMailingList(this.http, this.rootUrl, { id, body } satisfies UpdateMailingList$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateMailingList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateMailingList(id: number, body: UpdateMailingList$Params['body'], context?: HttpContext): Observable<FeatureMailingListsMailingListDto> {
    const resp = this.updateMailingList$Response(id, body, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FeatureMailingListsMailingListDto>): FeatureMailingListsMailingListDto => r.body)
    );
  }

}
